module.exports = __webpack_public_path__ + "static/media/2 (54).a9b2ce74.jpg";